/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ClassHoraireDto } from './ClassHoraireDto';
import {
    ClassHoraireDtoFromJSON,
    ClassHoraireDtoFromJSONTyped,
    ClassHoraireDtoToJSON,
} from './ClassHoraireDto';

/**
 * 
 * @export
 * @interface FcbClasseHorairesDto
 */
export interface FcbClasseHorairesDto {
    /**
     * 
     * @type {number}
     * @memberof FcbClasseHorairesDto
     */
    classeId?: number;
    /**
     * 
     * @type {Array<ClassHoraireDto>}
     * @memberof FcbClasseHorairesDto
     */
    classeHoraires?: Array<ClassHoraireDto> | null;
}

/**
 * Check if a given object implements the FcbClasseHorairesDto interface.
 */
export function instanceOfFcbClasseHorairesDto(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function FcbClasseHorairesDtoFromJSON(json: any): FcbClasseHorairesDto {
    return FcbClasseHorairesDtoFromJSONTyped(json, false);
}

export function FcbClasseHorairesDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): FcbClasseHorairesDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'classeId': !exists(json, 'classeId') ? undefined : json['classeId'],
        'classeHoraires': !exists(json, 'classeHoraires') ? undefined : (json['classeHoraires'] === null ? null : (json['classeHoraires'] as Array<any>).map(ClassHoraireDtoFromJSON)),
    };
}

export function FcbClasseHorairesDtoToJSON(value?: FcbClasseHorairesDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'classeId': value.classeId,
        'classeHoraires': value.classeHoraires === undefined ? undefined : (value.classeHoraires === null ? null : (value.classeHoraires as Array<any>).map(ClassHoraireDtoToJSON)),
    };
}

